import { render, staticRenderFns } from "./return-points-view.vue?vue&type=template&id=6d67e066&scoped=true&"
import script from "./return-points-view.vue?vue&type=script&lang=js&"
export * from "./return-points-view.vue?vue&type=script&lang=js&"
import style0 from "./return-points-view.vue?vue&type=style&index=0&id=6d67e066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67e066",
  null
  
)

export default component.exports